import { NzModalService } from 'ng-zorro-antd/modal';
import { Injectable } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';


@Injectable({ providedIn: 'root' })
export class DraftService {
	constructor(private modalService: NzModalService, private message: NzMessageService) {
	}
	private makeKey(type: string, id: number | undefined): string {
		return `draft_${type}_${id ?? 'new'}`;
	}
	hasDraft(type: string, id: number | undefined): boolean {
		return localStorage.getItem(this.makeKey(type, id)) != undefined;
	}
	saveAsDraft(type: string, id: number | undefined, data: any) {
		const payload = JSON.stringify(data);
		localStorage.setItem(this.makeKey(type, id), payload);
		this.message.success('Draft saved');
	}
	getDraft<T>(type: string, id: number | undefined): T {
		return JSON.parse(localStorage.getItem(this.makeKey(type, id))!);
	}
	removeDraft(type: string, id: number | undefined){
		localStorage.removeItem(this.makeKey(type, id));
	}
	prompt<T>(type: string, id: number | undefined, message: string = 'A draft already exists, do you want to resume?'): Observable<T | false> {
		const key = this.makeKey(type, id);
		if (!this.hasDraft(type, id)) {
			return of(false);
		}

		return new Observable<T | false>((subscriber) => {
			this.modalService.confirm({
				nzTitle: 'Draft Available',
				nzContent: message,
				nzOkText: 'Use Draft',
				nzCancelText: 'No',
				nzOnOk: () => {
					subscriber.next(this.hasDraft(type, id) ? this.getDraft(type, id) : false);
					subscriber.complete();
				},
				nzOnCancel: () => {
					this.removeDraft(type, id);
					subscriber.next(false);
					subscriber.complete();
				},
			});
		});
	}
}
